import CheckBoxIcon from "./CheckBoxIcon";

export default CheckBoxIcon;
